import * as React from "react";
import { Card } from "azure-devops-ui/Card";
import {
    CustomHeader,
    HeaderDescription,
    HeaderIcon,
    HeaderTitle,
    HeaderTitleArea,
    HeaderTitleRow,
    TitleSize
} from "azure-devops-ui/Header";
import { HeaderCommandBar } from "azure-devops-ui/HeaderCommandBar";
import { Page } from "azure-devops-ui/Page";
import { Status, Statuses, StatusSize } from "azure-devops-ui/Status";
import { commandBarItemsAdvanced } from "./HeaderData";

import "./Header.Example.css";

export default class HeaderExample extends React.Component<{}> {
    public render() {
        return (
            <Page>
                <CustomHeader className="bolt-header-with-commandbar header-example-advanced">
                    <HeaderIcon
                        className="bolt-table-status-icon-large"
                        iconProps={{ render: this.renderStatus }}
                        titleSize={TitleSize.Large}
                    />
                    <HeaderTitleArea>
                        <HeaderTitleRow>
                            <HeaderTitle ariaLevel={3} titleSize={TitleSize.Large}>
                                #3: Add new header to sample site
                            </HeaderTitle>
                        </HeaderTitleRow>
                        <HeaderDescription>
                            Validation of 405810 triggered today at 6:27 pm
                        </HeaderDescription>
                    </HeaderTitleArea>
                    <HeaderCommandBar items={commandBarItemsAdvanced} />
                </CustomHeader>

                <div className="page-content page-content-top">
                    <Card>Page content</Card>
                </div>
            </Page>
        );
    }

    private renderStatus = (className?: string) => {
        return <Status {...Statuses.Success} className={className} size={StatusSize.l} />;
    };
}
